import { Filter } from '../../../../components/UI/templates/TripTempateV2/trips.spec';
import MarketPlaceActionTypes from './types';
const initialState = {
  isfetching: false,
  snackbarState: { show: false, type: 'success', message: '' },
  operatorTripList: [],
  opTripsPageData: {
    totalPageCount: 0,
  },
  tripExpenseData: {},
  isFetchingTripTrackingData: false,
  tripTrackingData: {},
  isFetchingOperatorList: false,
  paymentHistoryData: {},
  tripSummaryData: [],
  isFetchingLoadsList: false,
  loadsListReceived: false,
  isFetchingStates: false,
  states: [],
  selectedState: '',
  loadsList: {
    loads: [],
  },
  loadSeen: {},
  opResponseSaved: false,
  opResponseRejected: false,
  loadDetails: {},
  leaderboard: null,
  postedLoadQuote: false,
  opQuoteAmount: null,
  firstAcceptance: false,
  opLoadsPageData: null,
  showBackWarning: false,
  quoteQuality: '',
  quoteQualityFetched: false,
  loadingPoints: [],

  placeholderDetails: {},
  placeholderCheck: false,
  unLoadingPoints: [],
  isFetchingUnloadingPoints: true,

  podResourceKey: [],
  ImageView: '',
  podColledted: '',
  ImageViewSingle: [],
  timeLeftUpdated: 0,

  podDetailData: {},
  imgFetching: null,
  uploadedDoc: false,
  vehicleAvailModalShow: '',

  surveyModalShow: false,
  surveyData: [],
  feedbackData: null,
  surveySubmitResponce: false,
  awsFullUrl: '',

  membershipPaymentDetails: {},
  membershipPaymentStatus: '',
  membershipPaymentProcessStatus: null,

  otpVerifiedSuccess: false,

  otpStageSuccess: false,
  subscriptionAmountInPaisa: null,
  operatorProfile: {},

  podDto: {},
  responseEventPosted: false,
  emptyValidator: false,
  operatorDetailsTds: {},
  operatorDetailsState: false,

  isFetching: false,
  errorText: '',
  tdsDeclared: false,
  detailPageApi: {},
  isFetchingAppConfig: false,
  appConfiguration: {},
  tripStateChangeValidationWidget: {},
  captureRemarks: {
    isFetching: false,
    slots: [],
    remarks: [],
  },
  ticketList: [],
  policyAcceptanceStatus: {},
  subscriptionConfig: {},
  cancelReasonSubmittedData: {},
  tripFilters: {
    isFetching: false,
    filters: [],
  },
  settings: [],
  settingsSaved: false,
  isPostingLoad: false,
  demandEditConfirmationData: null,
  ratingTraing: null,
  viewUrl: null,
  isUpdated: false,
  isUploaded: false,
  uploadedFilePath: null,
  weLang: null,
  isFetchingWeLang: false,
  isFetchedWeLang: false,
  trainingData: null,
  isTrainingCompleted: false,
  trainingContentV2Data: null,
  isFetchingTrainingContentV2: false,
  trainingContentV2Error: null,
  sessionUpdateData: null,
  isSessionUpdating: false,
  isInitialStateLoaded: false,
  detentionDetails: {},

  rateCards: null,
  stateChangeWidget: null,

  isReasonSubmitting: false,
  reasonSubmitError: null,
  reasonSubmitResponse: null,

  advanceStateViewData: null,
  isFetchingAdvanceStateView: false,
  advanceStateViewError: null,
};

const marketPlaceReducer = (state: any = initialState, action: { type: string; payload: any; typeOf: string }) => {
  switch (action.type) {
    case MarketPlaceActionTypes.FETCH_OPERATOR_TRIPS_START:
      return {
        ...state,
        isFetchingOperatorList: true,
      };

    case MarketPlaceActionTypes.CLEAR_OPERATOR_TRIPS:
      return {
        ...state,
        opTripsPageData: {},
        operatorTripList: [],
      };

    case MarketPlaceActionTypes.FETCH_OPERATOR_TRIPS_SUCCESS:
      return {
        ...state,
        isFetchingOperatorList: false,
        operatorTripList: [...state.operatorTripList, ...action.payload.trips],
        opTripsPageData: !!action.payload?.totalPageCount
          ? { pageNo: action.payload?.pageNo, totalPageCount: action.payload?.totalPageCount }
          : {},
      };

    case MarketPlaceActionTypes.FETCH_OPERATOR_TRIPS_FAILURE:
      return {
        ...state,
        isFetchingOperatorList: false,
        operatorTripList: [],
        opTripsPageData: {},
        errorMessage: action.payload.message,
      };

    case MarketPlaceActionTypes.FETCH_STATES_START:
      return {
        ...state,
        isFetchingStates: true,
      };

    case MarketPlaceActionTypes.FETCH_STATES_SUCCESS: {
      return {
        ...state,
        isFetchingStates: false,
        states: action.payload?.data?.states ?? [],
      };
    }

    case MarketPlaceActionTypes.FETCH_STATES_FAILURE:
      return {
        ...state,
        isFetchingStates: false,
      };

    case MarketPlaceActionTypes.FETCH_LOADS_START:
      return {
        ...state,
        isFetchingLoadsList: true,
        loadsListReceived: false,
        placeholderCheck: false,
        emptyValidator: false,
      };

    case MarketPlaceActionTypes.FETCH_LOADS_SUCCESS: {
      const loadsList = action.payload ?? [];
      const loadSeen: Record<string, boolean> = {};
      return {
        ...state,
        isFetchingLoadsList: false,
        loadsListReceived: true,
        placeholderCheck: true,
        loadsList: {
          loads: loadsList?.loads,
        },
        loadSeen: loadSeen,
        opLoadsPageData: !!action.payload?.data?.vehicleFreeWhatsapp,
        emptyValidator: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_LOADS_FAILURE:
      return {
        ...state,
        isFetchingLoadsList: false,
        loadsListReceived: false,
        loadsList: {
          loads: [],
        },
        loadSeen: {},
        opLoadsPageData: {},
        placeholderCheck: false,
        errorMessage: '',
        emptyValidator: false,
      };

    case MarketPlaceActionTypes.RESET_VALIDATOR_CHECK: {
      return {
        ...state,
        emptyValidator: false,
      };
    }

    case MarketPlaceActionTypes.SET_SELECTED_STATE:
      return {
        ...state,
        selectedState: action.payload,
      };

    case MarketPlaceActionTypes.SET_FIRST_ACCEPTANCE:
      return {
        ...state,
        firstAcceptance: action.payload,
      };

    case MarketPlaceActionTypes.SET_SHOW_BACK_WARNING:
      return {
        ...state,
        showBackWarning: action.payload,
      };

    case MarketPlaceActionTypes.SET_LOAD_SEEN:
      let updatedLoadSeen = state.loadSeen;
      if (!!action.payload && false === updatedLoadSeen[action.payload]) {
        updatedLoadSeen[action.payload] = true;
      }
      return {
        ...state,
        loadSeen: updatedLoadSeen,
      };

    case MarketPlaceActionTypes.SAVE_OP_QUOTE_AMOUNT:
      return {
        ...state,
        opQuoteAmount: action.payload,
      };

    case MarketPlaceActionTypes.RESET_OP_QUOTE_AMOUNT:
      return {
        ...state,
        opQuoteAmount: null,
      };

    case MarketPlaceActionTypes.SAVE_OP_RESPONSE_START:
      return {
        ...state,
        opResponseSaved: false,
        userSelectedDemandId: action.payload.demandId,
      };

    case MarketPlaceActionTypes.SAVE_OP_RESPONSE_SUCCESS:
      return {
        ...state,
        opResponseSaved: true,
      };

    case MarketPlaceActionTypes.SAVE_OP_RESPONSE_REJECTED:
      return {
        ...state,
        opResponseRejected: true,
      };

    case MarketPlaceActionTypes.CLEAR_LOADS_FLAGS:
      return {
        ...state,
        opResponseSaved: false,
        opResponseRejected: false,
      };

    case MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_START: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_SUCCESS: {
      return {
        ...state,
        tripExpenseData: action.payload,
        isFetching: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        isFetching: false,
      };
    }

    ///
    case MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_START: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_START_V2: {
      return {
        ...state,
        isFetching: true,
        isFetchingTripTrackingData: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_SUCCESS: {
      return {
        ...state,
        tripTrackingData: action.payload,
        isFetching: false,
        isFetchingTripTrackingData: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_FAILURE: {
      return {
        ...state,
        isFetching: false,
        detailPageApi: action.payload,
        isFetchingTripTrackingData: false,
      };
    }

    // tripTrackingDataReset
    case MarketPlaceActionTypes.TRIP_TRACKING_DATA_RESET: {
      return {
        ...state,
        tripTrackingData: {},
      };
    }

    case MarketPlaceActionTypes.MERGE_TRIP_POD_OTP_WIDGETS: {
      const { podOtpAndBalanceInfoTimer, podAndOtpSubmitWidget } = action.payload || {};
      return {
        ...state,
        tripTrackingData: {
          ...state.tripTrackingData,
          ...(podOtpAndBalanceInfoTimer !== undefined ? { podOtpAndBalanceInfoTimer } : {}),
          ...(podAndOtpSubmitWidget !== undefined ? { podAndOtpSubmitWidget } : {}),
        },
      };
    }

    //

    case MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_START: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_SUCCESS: {
      return {
        ...state,
        paymentHistoryData: action.payload,
        isFetching: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        isFetching: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_START: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_SUCCESS: {
      return {
        ...state,
        tripSummaryData: action.payload,
        isFetching: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        isFetching: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_LOAD_DETAILS_START: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_LOAD_DETAILS_SUCCESS: {
      return {
        ...state,
        loadDetails: action.payload,
        isFetching: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_LOAD_DETAILS_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.message,
        loadDetails: {},
        isFetching: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_LOAD_QUOTE_QUALITY_START: {
      return {
        ...state,

        quoteQualityFetched: false,
      };
    }

    case MarketPlaceActionTypes.FETCH_LOAD_QUOTE_QUALITY_SUCCESS: {
      return {
        ...state,
        quoteQuality: action.payload.value,
        timeLeftUpdated: action.payload.timeLeft,
        leaderboard: action.payload.leaderboard,
        quoteQualityFetched: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_LOAD_QUOTE_QUALITY_FAILURE: {
      return {
        ...state,
        leaderboard: null,
        errorMessage: action.payload.message,
        quoteQualityFetched: false,
      };
    }

    case MarketPlaceActionTypes.POST_LOAD_QUOTE_START:
      return {
        ...state,
        isPostingLoad: true,
        postedLoadQuote: false,
      };

    case MarketPlaceActionTypes.POST_LOAD_QUOTE_SUCCESS:
      return {
        ...state,
        isPostingLoad: false,
        postedLoadQuote: true,
      };

    case MarketPlaceActionTypes.POST_LOAD_QUOTE_FAILURE:
      return {
        ...state,
        isPostingLoad: false,
        postedLoadQuote: false,
      };

    case MarketPlaceActionTypes.POST_LOAD_QUOTE_RESET:
      return {
        ...state,
        postedLoadQuote: false,
      };

    case MarketPlaceActionTypes.GET_SEARCH_OPTIONS_START:
      let tempObject: any = {};
      tempObject = { ...state };
      if (action.payload === 'UNLOADING') {
        tempObject['unLoadingPoints'] = [];
      } else {
        tempObject['loadingPoints'] = [];
      }

      return tempObject;
    // return {
    //   ...state,
    //   // loadingPoints: [],
    // };
    case MarketPlaceActionTypes.GET_SEARCH_OPTIONS_SUCCESS:
      let tempObj: any = {};
      tempObj = { ...state };

      if (action.payload.payload === 'UNLOADING') {
        tempObj['unLoadingPoints'] = action.payload.data.data;
      } else {
        tempObj['loadingPoints'] = action.payload.data.data;
      }

      return tempObj;
    case MarketPlaceActionTypes.GET_SEARCH_OPTIONS_FAILURE:
      return {
        ...state,
        loadingPoints: [],
      };
    case MarketPlaceActionTypes.GET_PLACEHOLDER_BANNER_DETAILS_START:
      return {
        ...state,
        placeholderDetails: {},
      };
    case MarketPlaceActionTypes.GET_PLACEHOLDER_BANNER_DETAILS_SUCCESS:
      return {
        ...state,
        placeholderDetails: action.payload.data,
      };
    case MarketPlaceActionTypes.GET_PLACEHOLDER_BANNER_DETAILS_FAILURE:
      return {
        ...state,
        placeholderDetails: {},
      };

    case MarketPlaceActionTypes.GET_RESOURCE_KEY_POD:
      let anMainArray: any = [...state.podResourceKey];

      if (action.typeOf === 'update') {
        anMainArray.push({ res: action.payload });
      } else if (action.typeOf === 'delet') {
        if (action.payload !== -1) {
          anMainArray.splice(action.payload, 1);
        }
      } else {
        anMainArray = [];
      }

      return {
        ...state,
        podResourceKey: anMainArray,
      };

    case MarketPlaceActionTypes.GET_UPLOADED_IMAGES_START:
      return {
        ...state,
        // isDocSubmit:true,
        ImageView: '',
        podColledted: '',
        // ImageViewSingle:[],
      };
    case MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SUCCESS:
      return {
        ...state,
        // isDocSubmit:false,
        ImageView: action.payload.docViewUrl,
        podColledted: action.payload.collectPod,
      };

    case MarketPlaceActionTypes.GET_UPLOADED_IMAGES_FAILURE:
      return {
        ...state,
        // isDocSubmit:false,
        ImageView: '',
        podColledted: '',
        // ImageViewSingle:[],
      };

    case MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SINGLE_START:
      return {
        ...state,
        // isDocSubmit:true,
        imgFetching: false,

        ImageViewSingle: [],
      };
    case MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SINGLE_SUCCESS:
      return {
        ...state,
        // isDocSubmit:false,
        imgFetching: true,
        ImageViewSingle: [action.payload.viewUrl, ...state.ImageViewSingle],
      };

    case MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SINGLE_FAILURE:
      return {
        ...state,
        // isDocSubmit:false,
        imgFetching: false,

        ImageViewSingle: [],
      };

    case MarketPlaceActionTypes.FETCH_POD_DETAILS_START: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case MarketPlaceActionTypes.FETCH_POD_DETAILS_SUCCESS: {
      return {
        ...state,
        podDetailData: action.payload,
        isFetching: false,
      };
    }

    // case MarketPlaceActionTypes.FETCH_POD_DETAILS_SUCCESS: {
    //   return {
    //     ...state,
    //     errorMessage: action.payload.message,
    //     isFetching: false,
    //   };
    // }

    case MarketPlaceActionTypes.UNLOADING_SEARCH_RESULTS_START:
      return {
        ...state,
        unLoadingPoints: [],
        isFetchingUnloadingPoints: true,
      };
    case MarketPlaceActionTypes.UNLOADING_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        unLoadingPoints: action.payload.data.data,
        isFetchingUnloadingPoints: false,
      };
    case MarketPlaceActionTypes.UNLOADING_SEARCH_RESULTS_FAILURE:
      return {
        ...state,
        unLoadingPoints: [],
        isFetchingUnloadingPoints: false,
      };
    case MarketPlaceActionTypes.RESET_LIST:
      return {
        ...state,
        isFetchingUnloadingPoints: false,
        unLoadingPoints: [],
      };

    case MarketPlaceActionTypes.POST_AWS_SUCCESS:
      return {
        ...state,
        uploadedDoc: action.payload,
      };

    case MarketPlaceActionTypes.INITIATE_MEMBERSHIP_PAYMENT_SUCCESS: {
      const membershipPaymentDetailsPayload = action.payload?.data?.data || [];

      return {
        ...state,
        membershipPaymentDetails: membershipPaymentDetailsPayload,
        membershipPaymentStatus: membershipPaymentDetailsPayload.transactionStatus,
        membershipPaymentProcessStatus: null,
      };
    }

    case MarketPlaceActionTypes.INITIATE_MEMBERSHIP_PAYMENT_RESET: {
      return {
        ...state,
        membershipPaymentDetails: {},
        membershipPaymentStatus: '',
        membershipPaymentProcessStatus: null,
      };
    }

    case MarketPlaceActionTypes.MEMBERSHIP_PAYMENT_PROCESS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        membershipPaymentProcessStatus: 'SUCCESS',
      };
    }

    case MarketPlaceActionTypes.MEMBERSHIP_PAYMENT_PROCESS_FAILURE: {
      const data = action.payload;
      return {
        ...state,
        membershipPaymentProcessStatus: 'FAILURE',
      };
    }

    // case MarketPlaceActionTypes.POST_AWS_SUCCESS:
    //   return {
    //     ...state,
    //     uploadedDoc: 'true',

    // }

    case MarketPlaceActionTypes.SURVEY_GET_QUESTION_START:
      return {
        ...state,
        surveyModalShow: false,
        surveyData: {},
      };

    case MarketPlaceActionTypes.SURVEY_GET_QUESTION_SUCCESS:
      return {
        ...state,
        surveyModalShow: action.payload.show,
        surveyData: action.payload.data,
      };

    case MarketPlaceActionTypes.SURVEY_GET_QUESTION_FAILURE:
      return {
        ...state,
        surveyModalShow: false,
        surveyData: {},
      };

    case MarketPlaceActionTypes.POST_SURVEY_FORM_START:
      return {
        ...state,
        surveySubmitResponce: true,
      };

    case MarketPlaceActionTypes.POST_SURVEY_FORM_SUCCESS:
      return {
        ...state,
        surveySubmitResponce: action.payload.show,
      };

    case MarketPlaceActionTypes.POST_SURVEY_FORM_FAILURE:
      return {
        ...state,
        surveySubmitResponce: true,
      };

    case MarketPlaceActionTypes.POST_OTP_START:
      return {
        ...state,
        otpVerifiedSuccess: false,
      };

    case MarketPlaceActionTypes.POST_OTP_SUCCESS:
      return {
        ...state,
        otpVerifiedSuccess: action.payload,
      };

    case MarketPlaceActionTypes.POST_OTP_STAGE_START:
      return {
        ...state,
        otpStageSuccess: false,
      };

    case MarketPlaceActionTypes.POST_OTP_STAGE_SUCCESS:
      return {
        ...state,
        otpStageSuccess: true,
        stateChangeWidget: action.payload.stateChangeWidget,
      };
    case MarketPlaceActionTypes.POST_OTP_STAGE_FAILURE:
      return {
        ...state,
        stateChangeWidget: null,
      };

    case MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_START:
      return {
        ...state,
        tripStateChangeValidationWidget: action.payload,
      };

    case MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_STOP:
      return {
        ...state,
        tripStateChangeValidationWidget: {},
      };

    case MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_VALIDATION_START:
      return {
        ...state,
        tripDetailStateChangeValidation: false,
      };

    case MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_VALIDATION_SUCCESS:
      return {
        ...state,
        tripDetailStateChangeValidation: true,
      };

    case MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_VALIDATION_FAILURE:
      return {
        ...state,
        tripDetailStateChangeValidation: false,
      };

    case MarketPlaceActionTypes.GET_POD_IMG_AWS_URL:
      return {
        ...state,
        awsFullUrl: action.payload,
      };
    case MarketPlaceActionTypes.FETCH_OPERATOR_PROFILE_START:
      return {
        ...state,
        operatorProfile: {},
      };
    case MarketPlaceActionTypes.FETCH_OPERATOR_PROFILE_SUCCESS:
      return {
        ...state,
        operatorProfile: action.payload,
      };
    case MarketPlaceActionTypes.FETCH_OPERATOR_PROFILE_FAILURE:
      return {
        ...state,
        operatorProfile: {},
      };
    case MarketPlaceActionTypes.FETCH_APP_CONFIG:
      return {
        ...state,
        isFetching: true,
        subscriptionAmountInPaisa: null,
        loadScreen: '',
        showWarningBottomBanner: '',
        buyGpsLink: '',
        feedbackData: null,
        vehicleAvailModalShow: false,
        subscriptionTitle: '',
        surveyData: {},
      };
    case MarketPlaceActionTypes.FETCH_APP_CONFIG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        subscriptionAmountInPaisa: action.payload.subscriptionAmountInPaisa,
        loadScreen: action.payload.loadScreen,
        walletRechargeSource: action.payload.walletRechargeSource,
        showWarningBottomBanner: action.payload.showWarningBottomBanner,
        buyGpsLink: action.payload.buyGpsLink,
        feedbackData: action.payload.feedBackWidget,
        vehicleAvailModalShow: action.payload.show_vehicle_availability_card,
        subscriptionTitle: action.payload.subscriptionTitle,
        surveyData: action.payload,
      };
    case MarketPlaceActionTypes.FETCH_APP_CONFIG_FAILURE:
      return {
        ...state,
        isFetching: false,
        subscriptionAmountInPaisa: null,
        loadScreen: '',
        walletRechargeSource: '',
        showWarningBottomBanner: '',
        buyGpsLink: '',
        feedbackData: {},
        vehicleAvailModalShow: false,
        subscriptionTitle: '',

        surveyData: {},
      };
    case MarketPlaceActionTypes.POST_IMG_AWS:
      return {
        ...state,
        podDto: {
          ...state.podDto,
          currentImageUploadSuccess: false,
        },
      };
    case MarketPlaceActionTypes.POST_IMG_AWS_SUCCESS:
      const resourceKey = action.payload.resourceKey;
      const imgUrl = action.payload.imgUrl;
      const trip = action.payload.tripId;
      const resourceKeys = state.podDto[trip]?.resource ? [...state.podDto[trip].resource] : [];
      const object = {
        resourceKey,
        isUploadedSuccessFully: false,
      };
      return {
        ...state,
        podDto: {
          ...state.podDto,
          [trip]: { resource: [...resourceKeys, object], currentImageUrl: imgUrl },
          currentImageUploadSuccess: false,
        },
      };
    case MarketPlaceActionTypes.REMOVE_RESOURCE_KEY:
      const tripId = action.payload.tripId;
      const resourceIndex = action.payload.index;
      const resources = state.podDto[tripId]?.resource ? [...state.podDto[tripId].resource] : [];
      const filteredResource = resources.filter((_, index) => index !== resourceIndex);
      return {
        ...state,
        podDto: {
          ...state.podDto,
          [tripId]: { ...state.podDto[tripId], resource: filteredResource },
        },
      };

    case MarketPlaceActionTypes.IMG_UPLOAD_STATUS_SUCCESS:
      const d = action.payload.tripId;
      const res = action.payload.resourceKey;
      const resourcesKeys = state.podDto[d]?.resource ? [...state.podDto[d].resource] : [];

      const modifiedKey = (resKeys: any) =>
        resKeys.map((r: { resourceKey: any }) => {
          if (r.resourceKey === res) {
            return {
              ...r,
              isUploadedSuccessFully: true,
            };
          } else {
            return r;
          }
        });
      return {
        ...state,
        podDto: {
          ...state.podDto,
          [d]: { ...state.podDto[d], resource: [...modifiedKey(resourcesKeys)] },
          currentImageUploadSuccess: true,
        },
      };
    case MarketPlaceActionTypes.RESET_POD_DTO:
      return {
        ...state,
        podDto: {},
      };

    case MarketPlaceActionTypes.SEND_RESPONSE_EVENT_START:
      return {
        ...state,
        responseEventPosted: false,
      };
    case MarketPlaceActionTypes.SEND_RESPONSE_EVENT_SUCCESS:
      return {
        ...state,
        responseEventPosted: true,
      };
    case MarketPlaceActionTypes.SEND_RESPONSE_EVENT_FAILURE:
      return {
        ...state,
        responseEventPosted: false,
      };

    case MarketPlaceActionTypes.FETCH_OPERATOR_DETAILS_TDS_START: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_DETAILS_TDS_SUCCESS: {
      const listData = action.payload?.data || [];
      return {
        ...state,
        operatorDetailsTds: listData,
        operatorDetailsState: true,
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_DETAILS_TDS_FAILURE: {
      return {
        ...state,
      };
    }

    case MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_START: {
      return {
        ...state,
        tdsDeclared: false,
      };
    }

    case MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_SUCCESS: {
      return {
        ...state,
        tdsDeclared: true,
      };
    }

    case MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_FAILURE: {
      return {
        ...state,
        errorText: action.payload.response.data.message,
        tdsDeclared: false,
      };
    }
    case MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_RESRET: {
      return {
        ...state,
        tdsDeclared: false,
      };
    }

    case MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_DETAIL_RESET: {
      return {
        ...state,
        // operatorDetailsTds: {},
        operatorDetailsState: false,
      };
    }
    case MarketPlaceActionTypes.GET_APP_CONFIG_V2: {
      return {
        ...state,
        isFetchingAppConfig: true,
      };
    }
    case MarketPlaceActionTypes.GET_APP_CONFIG_V2_SUCCESS: {
      return {
        ...state,
        isFetchingAppConfig: false,
        appConfiguration: action.payload,
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_TICKETS_START: {
      return {
        ...state,
        isFetchingOperatorTickets: true,
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_TICKETS_SUCCESS: {
      return {
        ...state,
        isFetchingOperatorTickets: false,
        ticketList: action.payload.tickets,
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_TICKETS_FAILURE: {
      return {
        ...state,
        isFetchingOperatorTickets: false,
        ticketList: [],
      };
    }
    case MarketPlaceActionTypes.GET_TRIP_REMARKS: {
      return {
        ...state,
        captureRemarks: {
          isFetching: true,
          slots: [],
          remarks: [],
          heading: '',
        },
      };
    }
    case MarketPlaceActionTypes.GET_TRIP_REMARKS_SUCCESS: {
      const { reasons } = action.payload;
      const { heading } = action.payload;
      return {
        ...state,
        captureRemarks: {
          ...state.captureRemarks,
          isFetching: false,
          remarks: reasons,
          heading: heading,
        },
      };
    }
    case MarketPlaceActionTypes.GET_TRIP_REMARKS_FAILURE: {
      return {
        ...state,
        captureRemarks: {
          isFetching: false,
          slots: [],
          remarks: [],
          heading: '',
        },
      };
    }

    case MarketPlaceActionTypes.FETCH_SUBSCRIPTION_CONFIG: {
      return {
        ...state,
        subscriptionConfig: {},
      };
    }
    case MarketPlaceActionTypes.FETCH_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        subscriptionConfig: action.payload,
      };
    }
    case MarketPlaceActionTypes.FETCH_SUBSCRIPTION_FAILURE: {
      return {
        ...state,
        subscriptionConfig: {},
      };
    }

    case MarketPlaceActionTypes.GET_TIME_SLOTS: {
      return {
        ...state,
        captureRemarks: {
          ...state.captureRemarks,
          isFetching: true,
          slots: [],
          heading: '',
          infoWidget: {},
        },
      };
    }
    case MarketPlaceActionTypes.GET_TIME_SLOTS_SUCCESS: {
      const { slots } = action.payload;
      const { heading } = action.payload;
      const { infoWidget } = action.payload;

      return {
        ...state,
        captureRemarks: {
          ...state.captureRemarks,
          isFetching: false,
          slots: slots,
          heading: heading,
          infoWidget: infoWidget,
        },
      };
    }
    case MarketPlaceActionTypes.GET_TIME_SLOTS_FAILURE: {
      return {
        ...state,
        captureRemarks: {
          isFetching: false,
          slots: [],
          remarks: [],
          heading: '',
        },
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_START: {
      return {
        ...state,
        policyAcceptanceStatus: {},
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_SUCCESS: {
      return {
        ...state,
        policyAcceptanceStatus: action.payload,
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_FAILURE: {
      return {
        ...state,
        policyAcceptanceStatus: {},
      };
    }
    case MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_RESET: {
      return {
        ...state,
        policyAcceptanceStatus: {},
      };
    }

    case MarketPlaceActionTypes.POST_CANCEL_REASON: {
      return {
        ...state,
        cancelReasonSubmittedData: {},
      };
    }
    case MarketPlaceActionTypes.POST_CANCEL_REASON_SUCCESS: {
      return {
        ...state,
        cancelReasonSubmittedData: action.payload,
      };
    }
    case MarketPlaceActionTypes.POST_CANCEL_REASON_FAILURE: {
      return {
        ...state,
        cancelReasonSubmittedData: {},
      };
    }
    case MarketPlaceActionTypes.FETCH_TRIP_FILTERS: {
      return {
        ...state,
        tripFilters: {
          ...state.tripFilters,
          isFetching: true,
        },
      };
    }
    case MarketPlaceActionTypes.FETCH_TRIP_FILTERS_SUCCESS: {
      const { stateFilters } = action.payload;
      return {
        ...state,
        tripFilters: {
          ...state.tripFilters,
          isFetching: false,
          filters: stateFilters.map((f: any) => ({ ...f, selected: false })),
        },
      };
    }
    case MarketPlaceActionTypes.FETCH_TRIP_FILTERS_FAILURE: {
      return {
        ...state,
        tripFilters: {
          ...state.tripFilters,
          isFetching: false,
        },
      };
    }
    case MarketPlaceActionTypes.APPLY_FILTER: {
      const { key } = action.payload;
      return {
        ...state,
        tripFilters: {
          ...state.tripFilters,
          isFetching: false,
          filters: state.tripFilters.filters.map((filter: Filter) => {
            if (filter.key === key) {
              return {
                ...filter,
                selected: true,
              };
            } else
              return {
                ...filter,
                selected: false,
              };
          }),
        },
      };
    }
    case MarketPlaceActionTypes.FETCH_SETTINGS_REQUEST: {
      return {
        ...state,
        settings: [],
      };
    }
    case MarketPlaceActionTypes.FETCH_SETTINGS_SUCCESS: {
      return {
        ...state,
        settings: [action.payload.data],
      };
    }
    case MarketPlaceActionTypes.FETCH_SETTINGS_FAILURE: {
      return {
        ...state,
        settings: [],
      };
    }
    case MarketPlaceActionTypes.SAVE_SETTINGS_REQUEST: {
      return {
        ...state,
        settingsSaved: false,
      };
    }
    case MarketPlaceActionTypes.SAVE_SETTINGS_SUCCESS: {
      return {
        ...state,
        settingsSaved: true,
      };
    }
    case MarketPlaceActionTypes.SAVE_SETTINGS_FAILURE: {
      return {
        ...state,
        settingsSaved: false,
      };
    }
    case MarketPlaceActionTypes.DEMAND_EDIT_CONFIRMATION_REQUEST: {
      return {
        ...state,
        demandEditConfirmationData: null,
      };
    }
    case MarketPlaceActionTypes.DEMAND_EDIT_CONFIRMATION_SUCCESS: {
      return {
        ...state,
        demandEditConfirmationData: true,
      };
    }
    case MarketPlaceActionTypes.DEMAND_EDIT_CONFIRMATION_FAILURE: {
      return {
        ...state,
        demandEditConfirmationData: false,
      };
    }
    case MarketPlaceActionTypes.GET_RAITING_TRAINING_REQUEST: {
      return {
        ...state,
        ratingTraing: null,
      };
    }
    case MarketPlaceActionTypes.GET_RAITING_TRAINING_SUCCESS: {
      return {
        ...state,
        ratingTraing: action?.payload,
      };
    }
    case MarketPlaceActionTypes.GET_RAITING_TRAINING_FAILURE: {
      return {
        ...state,
        ratingTraing: null,
      };
    }
    case MarketPlaceActionTypes.GET_INVOICE_REQUEST: {
      return {
        ...state,
        viewUrl: null,
      };
    }
    case MarketPlaceActionTypes.GET_INVOICE_SUCCESS: {
      return {
        ...state,
        viewUrl: action?.payload?.viewUrl,
      };
    }
    case MarketPlaceActionTypes.GET_INVOICE_FAILURE: {
      return {
        ...state,
        viewUrl: null,
      };
    }
    case MarketPlaceActionTypes.PATCH_INVOICE_REQUEST: {
      return {
        ...state,
        isUpdated: false,
      };
    }
    case MarketPlaceActionTypes.PATCH_INVOICE_SUCCESS: {
      return {
        ...state,
        isUpdated: true,
      };
    }
    case MarketPlaceActionTypes.PATCH_INVOICE_FAILURE: {
      return {
        ...state,
        isUpdated: false,
      };
    }
    //2
    case MarketPlaceActionTypes.UPLOAD_IMAGE_REQUEST: {
      return {
        ...state,
        isUploaded: false,
      };
    }
    case MarketPlaceActionTypes.UPLOAD_IMAGE_SUCCESS: {
      return {
        ...state,
        isUploaded: true,
        uploadedFilePath: action.payload?.filePath,
      };
    }
    case MarketPlaceActionTypes.UPLOAD_IMAGE_FAILURE: {
      return {
        ...state,
        isUploaded: false,
        uploadedFilePath: null,
      };
    }
    //3
    case MarketPlaceActionTypes.UPLOAD_IMAGE_AWS_REQUEST: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.UPLOAD_IMAGE_AWS_SUCCESS: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.UPLOAD_IMAGE_AWS_FAILURE: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.FETCH_WELANG: {
      return {
        ...state,
        isFetchingWeLang: true,
        isFetchedWeLang: false,
      };
    }
    case MarketPlaceActionTypes.FETCH_WELANG_SUCCESS: {
      return {
        ...state,
        isFetchingWeLang: false,
        isFetchedWeLang: true,
        weLang: action.payload,
      };
    }

    case MarketPlaceActionTypes.GET_TRAINING_CONTENT_REQUEST: {
      return {
        ...state,
        trainingData: null,
      };
    }
    case MarketPlaceActionTypes.GET_TRAINING_CONTENT_SUCCESS: {
      return {
        ...state,
        trainingData: action.payload,
      };
    }

    case MarketPlaceActionTypes.PUT_COMPLETE_TRAINING_REQUEST: {
      return {
        ...state,
        isTrainingCompleted: false,
      };
    }
    case MarketPlaceActionTypes.PUT_COMPLETE_TRAINING_SUCCESS: {
      return {
        ...state,
        isTrainingCompleted: true,
      };
    }
    case MarketPlaceActionTypes.PUT_COMPLETE_TRAINING_FAILURE: {
      return {
        ...state,
        isTrainingCompleted: true,
      };
    }
    case MarketPlaceActionTypes.EMPTY_TRAINING_CONTENT: {
      return {
        ...state,
        trainingData: null,
      };
    }

    case MarketPlaceActionTypes.FETCH_TRAINING_CONTENT_V2_REQUEST: {
      return {
        ...state,
        isFetchingTrainingContentV2: true,
        trainingContentV2Error: null,
        trainingContentV2Data: null,
      };
    }
    case MarketPlaceActionTypes.FETCH_TRAINING_CONTENT_V2_SUCCESS: {
      return {
        ...state,
        isFetchingTrainingContentV2: false,
        trainingContentV2Data: action.payload,
        trainingContentV2Error: null,
      };
    }
    case MarketPlaceActionTypes.FETCH_TRAINING_CONTENT_V2_FAILURE: {
      return {
        ...state,
        isFetchingTrainingContentV2: false,
        trainingContentV2Error: 'Failed to fetch training content',
        trainingContentV2Data: null,
      };
    }

    // SESSION UPDATE API cases (common for all session operations)
    case MarketPlaceActionTypes.SESSION_UPDATE_REQUEST: {
      return {
        ...state,
        isSessionUpdating: true,
        sessionUpdateData: null,
        isInitialStateLoaded: false,
      };
    }
    case MarketPlaceActionTypes.SESSION_UPDATE_SUCCESS: {
      return {
        ...state,
        isSessionUpdating: false,
        sessionUpdateData: action.payload,
        isInitialStateLoaded: true,
      };
    }
    case MarketPlaceActionTypes.SESSION_UPDATE_FAILURE: {
      return {
        ...state,
        isSessionUpdating: false,
        sessionUpdateData: null,
        isInitialStateLoaded: true, // Show modal even on failure
      };
    }
    case MarketPlaceActionTypes.FETCH_DETENTION_CONTENT_REQUEST: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.FETCH_DETENTION_CONTENT_SUCCESS: {
      return {
        ...state,
        detentionDetails: action.payload,
      };
    }
    case MarketPlaceActionTypes.FETCH_DETENTION_CONTENT_FAILURE: {
      return {
        ...state,
        detentionDetails: {},
      };
    }

    case MarketPlaceActionTypes.FETCH_RATE_CARDS: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.FETCH_RATE_CARDS_SUCCESS: {
      return {
        ...state,
        rateCards: action.payload,
      };
    }
    case MarketPlaceActionTypes.FETCH_RATE_CARDS_FAILURE: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.SUBMIT_USER_RATE_CARD_RESPONSE: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.SUBMIT_USER_RATE_CARD_RESPONSE_SUCCESS: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.SUBMIT_USER_RATE_CARD_RESPONSE_FAILURE: {
      return {
        ...state,
      };
    }
    case MarketPlaceActionTypes.RESET_RATE_CARDS: {
      return {
        ...state,
        rateCards: {
          rateCards: [],
        },
      };
    }

    case MarketPlaceActionTypes.UPDATE_DELAY_REMARKS: {
      return {
        ...state,
        submitRemarks: false,
      };
    }

    case MarketPlaceActionTypes.UPDATE_DELAY_REMARKS_SUCCESS: {
      return {
        ...state,
        submitRemarks: true,
      };
    }
    case MarketPlaceActionTypes.UPDATE_DELAY_REMARKS_FAILURE: {
      return {
        ...state,
        submitRemarks: false,
      };
    }

    case MarketPlaceActionTypes.GET_REMARKS_LIST: {
      return {
        ...state,
        captureRemarksList: {
          isFetching: true,
          remarks: [],
        },
      };
    }
    case MarketPlaceActionTypes.GET_REMARKS_LIST_SUCCESS: {
      return {
        ...state,
        captureRemarksList: {
          ...state.captureRemarksList,
          isFetching: false,
          remarks: action.payload,
        },
      };
    }
    case MarketPlaceActionTypes.GET_REMARKS_LIST_FAILURE: {
      return {
        ...state,
        captureRemarksList: {
          ...state.captureRemarksList,
          isFetching: false,
          remarks: action.payload,
          // remarks: {
          //   header: {
          //     title: 'क्या QOQA_QOLA समय से अनलोडिंग पर पहुंच पाएगी?',
          //     buttons: [
          //       {
          //         label: 'हाँ, 20 दिसंबर 2024 शाम 6 बजे तक पहुंच जाएगी',
          //         action: 'DELAY_CAPTURE',
          //         colorEnum: null,
          //       },
          //       {
          //         label: 'नहीं',
          //         action: 'DECLINE_DELAY_CAPTURE',
          //         colorEnum: null,
          //       },
          //     ],
          //   },
          //   infoPrompt: {
          //     text: 'MP_TRANSIT_DELAY_TRIP_DETAIL_HEADING$$$$87000',
          //     color: 'YELLOW',
          //   },
          //   ctaItems: {
          //     heading: 'MP_TRANSIT_DELAY_REASON_PAGE_HEADING',
          //     subHeading: null,
          //     reasons: [
          //       {
          //         key: 'REASON1',
          //         display: 'reason1',
          //         subReason: [
          //           {
          //             key: 'SUB_REASON_1',
          //             display: 'subReason1',
          //           },
          //         ],
          //       },
          //       {
          //         key: 'REASON2',
          //         display: 'reason2',
          //         subReason: [
          //           {
          //             key: 'SUB_REASON_2',
          //             display: 'subReason2',
          //           },
          //         ],
          //       },
          //       {
          //         key: 'REASON3',
          //         display: 'reason3',
          //         subReason: [
          //           {
          //             key: 'SUB_REASON_3',
          //             display: 'subReason3',
          //           },
          //         ],
          //       },
          //       {
          //         key: 'REASON4',
          //         display: 'reason4',
          //         subReason: [
          //           {
          //             key: 'SUB_REASON_41',
          //             display: 'subReason41',
          //           },
          //           {
          //             key: 'SUB_REASON_42',
          //             display: 'subReason42',
          //           },
          //           {
          //             key: 'SUB_REASON_43',
          //             display: 'subReason43',
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   mapWidget: {
          //     locations: [
          //       {
          //         lat: 25.435409545898438,
          //         lng: 81.84608459472656,
          //         type: 'RED_SQUARE',
          //         addressInfo: 'प्रयागराज, उत्तर प्रदेश',
          //         tag: null,
          //       },
          //     ],
          //   },
          // },
        },
      };
    }

    case MarketPlaceActionTypes.REASON_SUBMIT_START:
      return {
        ...state,
        isReasonSubmitting: true,
        reasonSubmitError: null,
      };
    case MarketPlaceActionTypes.REASON_SUBMIT_SUCCESS:
      return {
        ...state,
        isReasonSubmitting: false,
        reasonSubmitResponse: action.payload,
      };
    case MarketPlaceActionTypes.REASON_SUBMIT_FAILURE:
      return {
        ...state,
        isReasonSubmitting: false,
        reasonSubmitError: action.payload,
      };

    case MarketPlaceActionTypes.FETCH_ADVANCE_STATE_VIEW_START:
      return {
        ...state,
        isFetchingAdvanceStateView: true,
        advanceStateViewError: null,
      };

    case MarketPlaceActionTypes.FETCH_ADVANCE_STATE_VIEW_SUCCESS:
      return {
        ...state,
        isFetchingAdvanceStateView: false,
        advanceStateViewData: action.payload,
      };

    case MarketPlaceActionTypes.FETCH_ADVANCE_STATE_VIEW_FAILURE:
      return {
        ...state,
        isFetchingAdvanceStateView: false,
        advanceStateViewError: action.payload,
      };

    default:
      return state;
  }
};

export default marketPlaceReducer;
